import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import AdminReport from 'src/components/admin/AdminReport';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(LandscapingGame)'
interface AdminReportsProps extends RouteComponentProps<{}> {
}

interface AdminReportsState {
}

class AdminReports extends React.Component<AdminReportsProps, AdminReportsState> {
    constructor(props: AdminReportsProps) {
        super(props);
        bindAllOfThis(this, AdminReports.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    render() {
        return <div>
            <AdminReport />
        </div>;
    }
}

export default AdminReports;



// WEBPACK FOOTER //
// ./src/pages/admin/AdminReports.tsx